import {
  validatedmmpm5lnzq3lm as validated,
  validated3dw9xce8adqbh as validated_0,
} from './entrypoints.mjs';
import {
  _ReactiveState___init__impl__fvdp9b2eqyidpf491cp as _ReactiveState___init__impl__fvdp9b,
  _ReactiveState___get_raw__impl__92ipya10f5f3x6hwqt0 as _ReactiveState___get_raw__impl__92ipya,
  InternalReactiveWrapper6qytbrc1rcqv as InternalReactiveWrapper,
  InternalReactiveThrownException1wn4fe03qbefg as InternalReactiveThrownException,
  InternalReactiveNotReady_instance37iasaqvolrrz as InternalReactiveNotReady_instance,
  ReactiveStatel8ixobo86msn as ReactiveState,
} from '../../core/ReactiveState.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  equals2au1ep9vhcato as equals,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  Warning3n5ye4cehejrw as Warning,
  IssueNode2x8c6ia7dmfdz as IssueNode,
} from './IssueNode.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  lensi9s8q1zaykbw as lens,
  lens2dr2mfn274h1a as lens_0,
  MutableValidated2ognu5vxf17ur as MutableValidated,
  lens2gvfhjoqnpofs as lens_1,
  lens2wuprihu5z787 as lens_2,
  MutableValidatedValuegls7jkstsdwb as MutableValidatedValue,
} from './Validated.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  valueSet3cf2hvvu95f3 as valueSet,
  set1y8eiqnqugbz3 as set,
  getValue6qi464mhg2s5 as getValue,
  setValue39oxnnnmdq4h2 as setValue,
  Reactive1jy75v4li6ldv as Reactive,
  ReactiveValue37mnzha3zo6xb as ReactiveValue,
} from '../../core/coreInterfaces.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  BaseReactive302n39o7i5yop as BaseReactive,
  BaseReactiveValue1ggyqczzm31cy as BaseReactiveValue,
} from '../../core/abstracts.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function checkForIssue(_this__u8e3s4, validate) {
  return MutableValidationLens().yav(_this__u8e3s4, validate);
}
function checkForIssue_0(_this__u8e3s4, validate) {
  return ValidationValueLens().gaw(_this__u8e3s4, validate);
}
function checkForIssue_1(_this__u8e3s4, validate) {
  return MutableValidationLens().yav(validated(_this__u8e3s4), validate);
}
function checkForIssue_2(_this__u8e3s4, validate) {
  return ValidationValueLens().gaw(validated_0(_this__u8e3s4), validate);
}
function *_generator_set__cb7isu($this, value, $completion) {
  var issue = $this.kaw_1(value);
  $this.law_1.tat(issue);
  protoOf(ValidatedLens()).rah.call($this, _ReactiveState___init__impl__fvdp9b(value));
  var tmp;
  if (issue == null) {
    tmp = true;
  } else {
    tmp = issue instanceof Warning();
  }
  if (tmp) {
    // Inline function 'com.lightningkite.reactive.lensing.validation.ValidatedLens.withoutListening' call
    $this.naw_1 = false;
    var tmp_0 = $this.jaw_1.iah(value, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    $this.naw_1 = true;
  }
  return Unit_instance;
}
var MutableValidationLensClass;
function MutableValidationLens() {
  if (MutableValidationLensClass === VOID) {
    class $ extends ValidatedLens() {
      static yav(source, validate) {
        return this.oaw(source, validate);
      }
      iah(value, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_set__cb7isu.bind(VOID, this, value), $completion);
      }
    }
    protoOf($).vak = lens;
    protoOf($).dak = lens_0;
    initMetadataForClass($, 'MutableValidationLens', VOID, VOID, [MutableValidated(), ValidatedLens()], [1]);
    MutableValidationLensClass = $;
  }
  return MutableValidationLensClass;
}
var ValidationValueLensClass;
function ValidationValueLens() {
  if (ValidationValueLensClass === VOID) {
    class $ extends ValidatedValueLens() {
      static gaw(source, validate) {
        return this.waw(source, validate);
      }
      oam(value) {
        var issue = this.saw_1(value);
        this.taw_1.tat(issue);
        super.oam(value);
        var tmp;
        if (issue == null) {
          tmp = true;
        } else {
          tmp = issue instanceof Warning();
        }
        if (tmp) {
          // Inline function 'com.lightningkite.reactive.lensing.validation.ValidatedValueLens.withoutListening' call
          this.vaw_1 = false;
          this.raw_1.oam(value);
          this.vaw_1 = true;
        }
      }
      f2() {
        return super.f2();
      }
      qam(thisRef, property) {
        return this.pam((thisRef == null ? true : !(thisRef == null)) ? thisRef : THROW_CCE(), property);
      }
      sam(thisRef, property, value) {
        var tmp = (thisRef == null ? true : !(thisRef == null)) ? thisRef : THROW_CCE();
        return this.ram(tmp, property, (value == null ? true : !(value == null)) ? value : THROW_CCE());
      }
    }
    protoOf($).vak = lens_1;
    protoOf($).dak = lens_2;
    protoOf($).eak = valueSet;
    protoOf($).iah = set;
    protoOf($).pam = getValue;
    protoOf($).ram = setValue;
    initMetadataForClass($, 'ValidationValueLens', VOID, VOID, [MutableValidatedValue(), ValidatedValueLens()], [1]);
    ValidationValueLensClass = $;
  }
  return ValidationValueLensClass;
}
function check($this, state) {
  // Inline function 'com.lightningkite.reactive.core.ReactiveState.onSuccess' call
  // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
  var tmp0_subject = _ReactiveState___get_raw__impl__92ipya(state);
  var tmp;
  if (equals(tmp0_subject, InternalReactiveNotReady_instance)) {
    tmp = null;
  } else {
    if (tmp0_subject instanceof InternalReactiveThrownException()) {
      _ReactiveState___get_raw__impl__92ipya(state).uah_1;
      tmp = null;
    } else {
      if (tmp0_subject instanceof InternalReactiveWrapper()) {
        var tmp_0 = _ReactiveState___get_raw__impl__92ipya(state).tah_1;
        var value = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
        $this.law_1.tat($this.kaw_1(value));
        tmp = Unit_instance;
      } else {
        var value_0 = _ReactiveState___get_raw__impl__92ipya(state);
        $this.law_1.tat($this.kaw_1(value_0));
        tmp = Unit_instance;
      }
    }
  }
  return tmp;
}
var ValidatedLensClass;
function ValidatedLens() {
  if (ValidatedLensClass === VOID) {
    class $ extends BaseReactive() {
      static oaw(source, validate) {
        var $this = this.ial(source.sah());
        $this.jaw_1 = source;
        $this.kaw_1 = validate;
        $this.law_1 = new (IssueNode())($this.jaw_1.xat());
        $this.maw_1 = null;
        $this.naw_1 = true;
        return $this;
      }
      xat() {
        // Inline function 'kotlin.also' call
        var this_0 = this.law_1;
        if (this.maw_1 == null) {
          check(this, this.jaw_1.sah());
        }
        return this_0;
      }
      rah(value) {
        super.rah(value);
      }
      sah() {
        if (this.maw_1 == null) {
          // Inline function 'kotlin.also' call
          var this_0 = new (ReactiveState())(this.jaw_1.sah());
          var p0 = this_0.iao_1;
          check(this, p0);
          var tmp$ret$1 = this_0.iao_1;
          super.rah(tmp$ret$1);
        }
        return super.sah();
      }
      kal() {
        super.kal();
        this.law_1.wat();
        // Inline function 'kotlin.also' call
        var this_0 = new (ReactiveState())(this.jaw_1.sah());
        var p0 = this_0.iao_1;
        check(this, p0);
        var tmp$ret$1 = this_0.iao_1;
        this.rah(tmp$ret$1);
        var tmp = this;
        tmp.maw_1 = this.jaw_1.vah(() => {
          var tmp;
          if (this.naw_1) {
            // Inline function 'kotlin.also' call
            var this_0 = new (ReactiveState())(this.jaw_1.sah());
            var p0 = this_0.iao_1;
            check(this, p0);
            var tmp$ret$3 = this_0.iao_1;
            this.rah(tmp$ret$3);
            tmp = Unit_instance;
          }
          return Unit_instance;
        });
      }
      lal() {
        super.lal();
        this.law_1.sat();
        var tmp0_safe_receiver = this.maw_1;
        if (tmp0_safe_receiver == null)
          null;
        else
          tmp0_safe_receiver();
        this.maw_1 = null;
      }
    }
    initMetadataForClass($, 'ValidatedLens', VOID, VOID, [Reactive(), BaseReactive()]);
    ValidatedLensClass = $;
  }
  return ValidatedLensClass;
}
function check_0($this, value) {
  return $this.taw_1.tat($this.saw_1(value));
}
var ValidatedValueLensClass;
function ValidatedValueLens() {
  if (ValidatedValueLensClass === VOID) {
    class $ extends BaseReactiveValue() {
      static waw(source, validate) {
        var $this = this.xao(source.f2());
        $this.raw_1 = source;
        $this.saw_1 = validate;
        $this.taw_1 = new (IssueNode())($this.raw_1.xat());
        $this.uaw_1 = null;
        $this.vaw_1 = true;
        return $this;
      }
      xat() {
        // Inline function 'kotlin.also' call
        var this_0 = this.taw_1;
        if (this.uaw_1 == null) {
          check_0(this, this.raw_1.f2());
        }
        return this_0;
      }
      oam(value) {
        super.oam(value);
      }
      f2() {
        if (this.uaw_1 == null) {
          // Inline function 'kotlin.also' call
          var this_0 = this.raw_1.f2();
          check_0(this, this_0);
          super.oam(this_0);
        }
        return super.f2();
      }
      kal() {
        super.kal();
        this.taw_1.wat();
        // Inline function 'kotlin.also' call
        var this_0 = this.raw_1.f2();
        check_0(this, this_0);
        this.oam(this_0);
        var tmp = this;
        tmp.uaw_1 = this.raw_1.vah(() => {
          var tmp;
          if (this.vaw_1) {
            // Inline function 'kotlin.also' call
            var this_0 = this.raw_1.f2();
            check_0(this, this_0);
            this.oam(this_0);
            tmp = Unit_instance;
          }
          return Unit_instance;
        });
      }
      lal() {
        super.lal();
        this.taw_1.sat();
        var tmp0_safe_receiver = this.uaw_1;
        if (tmp0_safe_receiver == null)
          null;
        else
          tmp0_safe_receiver();
        this.uaw_1 = null;
      }
    }
    initMetadataForClass($, 'ValidatedValueLens', VOID, VOID, [Reactive(), ReactiveValue(), BaseReactiveValue()]);
    ValidatedValueLensClass = $;
  }
  return ValidatedValueLensClass;
}
//region block: exports
export {
  checkForIssue_0 as checkForIssuekofyrsbkkylg,
  checkForIssue as checkForIssue33eljrw8xgf34,
  checkForIssue_1 as checkForIssue1hr94zacaxdsk,
  checkForIssue_2 as checkForIssue13p10uahnmugb,
};
//endregion

//# sourceMappingURL=validation.mjs.map
